const DEFAULT_PER_PAGE = 10;

export default DEFAULT_PER_PAGE;
